(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/services/services-links.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/services/services-links.js');
'use strict';

const Icon = svs.ui.ReactIcon;
const _svs$ui$ReactListGrou = svs.ui.ReactListGroup,
  ListGroup = _svs$ui$ReactListGrou.ListGroup,
  ListItem = _svs$ui$ReactListGrou.ListItem,
  ItemHeader = _svs$ui$ReactListGrou.ItemHeader;
const baseUrl = svs.core.data.baseUrl;
const ServiceLinks = _ref => {
  let services = _ref.services;
  return React.createElement(ListGroup, {
    className: "ticket-service-links",
    menu: true
  }, services.map(service => React.createElement(ListItem, {
    key: service.title
  }, React.createElement("a", {
    className: "qa-service-link",
    href: "".concat(baseUrl, "/").concat(service.anchor)
  }, React.createElement(ItemHeader, null, React.createElement(Icon, {
    icon: service.icon,
    size: "300"
  }), React.createElement("span", null, service.title), React.createElement(Icon, {
    icon: "menu-right",
    size: "300"
  }))))));
};
setGlobal('svs.tickets.next.components.services.ServiceLinks', ServiceLinks);

 })(window);